<app-multi-select-input
    [form]="form()"
    id="ruleIds"
    label="acl.rule.labelMulti"
    valueKey="id"
    labelKey="name"
    filterBy="name"
    display="chip"
    [showClear]="true"
    [staticOptions]="store.rules()"
    [disabled]="disabled()"
    [zIndex]="1005"
>
</app-multi-select-input>
